<template>
<div class="right-content">
  <div class="statistics-bar">
    <el-row>
      <el-col
        :xs="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
      >
        <div class="bar-item">
          <div
            class="icon-box"
            :style="iconStyle"
          >
            <icon-svg
              icon-class="guanlizijin"
              class="icon-el"
            />
          </div>
          <div class="icon-right">
            <div class="text">{{$t('Manage_funds')}}</div>
            <div class="data">{{rowData.managementAmount}} {{currency}}</div>
          </div>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
      >
        <div class="bar-item">
          <div
            :style="iconStyle"
            class="icon-box">
            <icon-svg
              icon-class="dingyueshouyi"
              class="icon-el"
            />
          </div>
          <div class="icon-right">
            <div class="text">{{$t('Subscription_revenue')}}</div>
            <div
              class="data green"
              :class="{red: (rowData.statProfit + '').includes('-')}"
            >{{rowData.statProfit}} {{currency}}</div>
          </div>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
      >
        <div class="bar-item">
          <div
            :style="iconStyle"
            class= "icon-box"
          >
            <icon-svg
              icon-class="zidongxufei"
              class="icon-el"
            />
          </div>
          <div class="icon-right">
            <div class="text">{{$t('Automatic_renewal')}}</div>
            <div class="data">{{rowData.isRenew === 1 ? $t('Yes'): $t('Not')}}</div>
          </div>
        </div>
      </el-col>
      <el-col
        :xs="12"
        :sm="12"
        :md="6"
        :lg="6"
        :xl="6"
      >
        <div class="bar-item">
          <div
            :style="iconStyle"
            class="icon-box">
            <icon-svg
              icon-class="yongjinmingxi"
              class="icon-el"
            />
          </div>
          <div class="icon-right">
            <div class="text">
              {{$t('Allocation')}}
            </div>
            <div class="data">{{getStrategy(rowData, self)}}</div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
  <div class="gray-bar"></div>
  <earnings-line-echart
    :row-data="rowData"
  ></earnings-line-echart>
  <div class="gray-bar"></div>
  <transaction-period-mam-sub
    :sub-id="rowData.subId"
  ></transaction-period-mam-sub>
  <div class="gray-bar"></div>
  <order-list
    :date-time="rowData"
    class="order-list-el"
  ></order-list>
</div>
</template>

<script>
import { getStrategy } from '@/utils/common';
import transactionPeriodMamSub from '@/components/user/details/mamSub/overview/transactionPeriod/transactionPeriodMamSub'
import earningsLineEchart from '@/components/user/details/mamSub/overview/earnings/earningsLineEchart'
import orderList from '@/components/user/details/common/order/orderList'
import {colorRgba} from "@/utils";
import { mapGetters } from 'vuex'
export default {
  name: "rightContent",
  components:{
    earningsLineEchart,
    transactionPeriodMamSub,
    orderList,
  },
  props: {
    rowData: {
      type: Object,
      default(){
        return {
          managementAmount: '',
          statProfit: '',
          renewal: 1,
          allocation: 1,
        }
      }
    },
  },
  data() {
    return {
      green: '#28C76F',
      self: {}
    }
  },
  computed:{
    ...mapGetters(['themeColor']),
    currency(){
      return 'USD';
    },
    iconStyle(){
      return {
        backgroundColor: colorRgba(this.themeColor,0.1),
        color: this.themeColor,
      }
    }
  },
  created(){
    this.self = this;
  },
  methods: {
    getStrategy,
  },
}
</script>

<style lang="scss" scoped>
.right-content {
  .statistics-bar {
    padding: 20px;
    padding-bottom: 5px;
    .bar-item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 14px;
      margin-bottom: 15px;
      .icon-box {
        width: 36px;
        height: 36px;
        margin-right: 12px;
        border-radius: 4px;
        background-color: #ffffff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .icon-el {
          font-size: 20px;
        }
      }
      .text {
        color: #5E5873;
        margin-bottom: 5px;
      }
      .data {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }
  .green {
    color: #28C76F;
  }
  .gray-bar {
    height: 15px;
    background-color: #F8F8F8;
  }
  .red {
    color: #E74B3A;
  }
}
</style>
